import { HTMLProps, useContext } from "react"
import { IconName } from "@/components/icons/icons"
import { CanvasControlsContext } from "@/components/canvas-controls/CanvasControlsContext"
import { Icon } from "@/components/icons/Icon"
import { useEditor } from "@/utils/useEditor"
import clsx from "clsx"

interface PinProps extends HTMLProps<SVGRectElement> {
	x: number
	y: number
	name: IconName
	opacity?: number
	active?: boolean
}

export const Pin = ({
	x,
	y,
	name,
	size = 14,
	opacity = 1.0,
	active = false,
	...props
}: PinProps) => {
	const editor = useEditor()
	const { parentX, parentY, parentWidth, parentHeight } = useContext(CanvasControlsContext)

	const cx = parentX + x * parentWidth
	const cy = parentY + y * parentHeight

	const transform = `
		translate(${cx - size / 2}, ${cy - size / 2}) 
		rotate(${-editor.rotation} ${size / 2} ${size / 2})
	`

	return (
		<g transform={transform} opacity={opacity}>
			<rect
				x={0 - 1}
				y={0 - 1}
				width={size + 2}
				height={size + 2}
				rx={3}
				ry={3}
				className={clsx(
					"cursor-default hover:fill-base-700",
					active ? "fill-accent-500" : "fill-base-900",
				)}
				{...props}
			/>
			<Icon className="pointer-events-none" name={name} size={size} />
		</g>
	)
}
